module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-aure-wood-grigio-marrone-milled.110e751e.jpg";